import ConditionallyProceedInfoBanner from "./ConditionallyProceedInfoBanner";

export default ConditionallyProceedInfoBanner;
